import { render, staticRenderFns } from "./LettersList.vue?vue&type=template&id=c8477584&scoped=true"
import script from "./LettersList.vue?vue&type=script&lang=js"
export * from "./LettersList.vue?vue&type=script&lang=js"
import style0 from "./LettersList.vue?vue&type=style&index=0&id=c8477584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8477584",
  null
  
)

export default component.exports